





























import { Component, Vue, Prop } from "vue-property-decorator";
import { postProcessMagicLink } from "../api";
import Card from "./Card.vue";
import { namespace } from "vuex-class";

const authStore = namespace("auth");

@Component({
  components: { Card },
})
export default class LoginProcessCard extends Vue {
  @authStore.Action setLoggedIn!: (state: boolean) => Promise<void>;

  @Prop({ required: true })
  token!: string;

  pending = true;
  success = false;

  async processToken(): Promise<void> {
    try {
      await postProcessMagicLink(this.token);
      this.success = true;
      this.setLoggedIn(true);
    } catch (e) {
      this.success = false;
    }
    this.pending = false;
  }

  mounted(): void {
    this.processToken();
  }
}
